import { formatNumber } from "@angular/common";

export function formatDaysAsYears(ageInDays: number | undefined): string {
  const daysPerYear = 365.25;
  const locale = "en-US";
  return `${formatNumber((ageInDays??0) / daysPerYear, locale, '1.0-1')} years`;
}
